import moment from "moment";
import {
  AIRLINE_CODES,
  AIRLINE_CONTACT_EMAILS
} from "../../helpers/airline-codes";
import { useMeData } from "../../hooks/useMe";

// const AA_EMAIL = "AAGMT.Topaccounts@aa.com";
const GREG_EMAIL = "gregh@worldstrides.org";
const AURA_EMAIL = "aura@saxecap.com";
const PRIMARY_PLANNER_EMAILS = {
  "GH/LS": "gregh@worldstrides.org",
  GH: "gregh@worldstrides.org",
  "KA/BIK": "kathya@worldstrides.org",
  KA: "kathya@worldstrides.org",
  "LHH/LHH": "leahh@worldstrides.org",
  LHH: "leahh@worldstrides.org",
  "MSQ/MSQ": "meenas@worldstrides.org",
  MSQ: "meenas@worldstrides.org",
  "DAA/DAA": "dana@worldstrides.org",
  DAA: "dana@worldstrides.org",
  "NS/GBJ": "nickies@worldstrides.org",
  NS: "nickies@worldstrides.org",
  "KGG/DBU": "kellig@worldstrides.org",
  LCI: "lisacl@goworldpass.com",
  DBU: "dustinb@worldstrides.org",
  "DBU/DBU": "dustinb@worldstrides.org",
  "EWS/EWS": "ethanw@worldstrides.org",
  EWS: "ethanw@worldstrides.org",
  "JHK/JHK": "jeremy.hopkins@worldstrides.org",
  JHK: "jeremy.hopkins@worldstrides.org",
  "KGG/KGG": "kellig@worldstrides.org",
  KGG: "kellig@worldstrides.org"
};

export function useSendEmailFactory(data) {
  const to = AIRLINE_CONTACT_EMAILS[toTwoLetterCode(data, 0)];
  const subject = `Subject: Group ${data["Group#"]}/Can I get ${data["num_passengers"]} seats for this group? IATA 49732815/Phone 434-982-8675`;

  const body = constructBody(data);

  const currentUserEmail = useMeData().email.toLowerCase();
  const primaryPlannerEmail = PRIMARY_PLANNER_EMAILS[data["Planner"]];
  const cc =
    !primaryPlannerEmail || primaryPlannerEmail === currentUserEmail
      ? []
      : [primaryPlannerEmail];

  const bcc = [GREG_EMAIL, AURA_EMAIL];

  return () => {
    return window.open(createMailtoLink(to, subject, body, cc, bcc));
  };
}

export function createMailtoLink(to, subject, body, cc = [], bcc = []) {
  subject = encodeURIComponent(subject);
  body = encodeURIComponent(body);
  let link = `mailto:${to}?subject=${subject}&body=${body}`;
  if (cc.length) link += `&cc=${cc.map(encodeURIComponent).join(",")}`;
  if (bcc.length) link += `&bcc=${bcc.map(encodeURIComponent).join(",")}`;
  return link;
}

function constructBody(data) {
  if (data["stop_1"] && data["stop_1"].length) {
    return constructBodyFromTripleFlightTripLeg(data);
  } else if (data["stop_0"] && data["stop_0"].length) {
    return constructBodyFromDoubleFlightTripLeg(data);
  } else {
    return constructBodyFromSingleFlightTripLeg(data);
  }
}

function constructBodyFromSingleFlightTripLeg(data) {
  return constructBodyLine(data, 0);
}

function constructBodyLine(data, flight_index) {
  const orig = data[`orig_${flight_index}`];
  const dest = data[`dest_${flight_index}`];
  const flightno = formatFlightNumber(data, flight_index);
  const depDate = formatDepartDate(data, flight_index);
  const depTime = formatDepartTime(data, flight_index);
  const arvDate = formatArriveDate(data, flight_index);
  const arvTime = formatArriveTime(data, flight_index);
  return `${flightno} ${depDate} ${orig}${dest} ${depTime} ${arvTime} ${arvDate}`;
}

function constructBodyFromDoubleFlightTripLeg(data) {
  return [constructBodyLine(data, 0), constructBodyLine(data, 1)].join("\n");
}

function constructBodyFromTripleFlightTripLeg(data) {
  return [
    constructBodyLine(data, 0),
    constructBodyLine(data, 1),
    constructBodyLine(data, 2)
  ].join("\n");
}

function formatFlightNumber(data, flight_index) {
  return (
    toTwoLetterCode(data, flight_index) + data[`flight_number_${flight_index}`]
  );
}

function formatDepartDate(data, flight_index) {
  const departsAt = data[`departs_at_${flight_index}`];
  return formatDate(departsAt);
}

function formatDate(value) {
  return momentify(value)
    .format("DDMMM")
    .toUpperCase();
}

function formatTime(value) {
  return momentify(value).format("hmmP");
}

function momentify(value) {
  return moment(value).utc(false);
}

function formatDepartTime(data, flight_index) {
  const departsAt = data[`departs_at_${flight_index}`];
  return formatTime(departsAt);
}

function formatArriveDate(data, flight_index) {
  const arrivesAt = data[`arrives_at_${flight_index}`];
  return formatDate(arrivesAt);
}

function formatArriveTime(data, flight_index) {
  const arrivesAt = data[`arrives_at_${flight_index}`];
  return formatTime(arrivesAt);
}
function toTwoLetterCode(data, flight_index) {
  const airline = data[`carrier_${flight_index}`];
  return AIRLINE_CODES[airline] || airline;
}
